import { RecurrenceType } from '../models/RecurrenceType';

/** The recurrence types reachable only through the "Custom" frequency option. */
export const CUSTOM_RECURRENCE_TYPES: RecurrenceType[] = [
  RecurrenceType.BiWeekly,
  RecurrenceType.EveryThirdWeek,
  RecurrenceType.EveryFourthWeek,
  RecurrenceType.DailyWeekend,
  RecurrenceType.MonthlyFirstDay,
];

/**
 * Maps frequency string values from the UI to RecurrenceType enum values
 * @param frequency - The frequency string from the form
 * @returns The corresponding RecurrenceType enum value
 */
export const mapFrequencyToRecurrenceType = (frequency: string): RecurrenceType => {
  switch (frequency) {
    case 'none':
      return RecurrenceType.No;
    case 'daily':
      return RecurrenceType.Daily;
    case 'weekday':
      return RecurrenceType.DailyWorkdays;
    case 'weekly':
      return RecurrenceType.Weekly;
    case 'monthly':
      return RecurrenceType.MonthlyDayNumber;
    case 'custom':
      // The custom cadence selector refines this further (every 2/3/4 weeks, …).
      return RecurrenceType.BiWeekly;
    default:
      return RecurrenceType.No;
  }
};

/**
 * Maps RecurrenceType enum values to frequency string values for the UI
 * @param recurrenceType - The RecurrenceType enum value from the API (can be string or number)
 * @returns The corresponding frequency string for the form
 */
export const mapRecurrenceTypeToFrequency = (recurrenceType: RecurrenceType | string): string => {
  // Handle both string and numeric values from API
  let normalizedType: RecurrenceType;

  if (typeof recurrenceType === 'string') {
    // If it's a string, it should match the enum value directly now
    normalizedType = recurrenceType as RecurrenceType;
  } else {
    normalizedType = recurrenceType;
  }

  switch (normalizedType) {
    case RecurrenceType.No:
      return 'none';
    case RecurrenceType.Daily:
      return 'daily';
    case RecurrenceType.DailyWorkdays:
      return 'weekday';
    case RecurrenceType.Weekly:
      return 'weekly';
    case RecurrenceType.MonthlyDayNumber:
      return 'monthly';
    case RecurrenceType.BiWeekly:
    case RecurrenceType.EveryThirdWeek:
    case RecurrenceType.EveryFourthWeek:
    case RecurrenceType.DailyWeekend:
    case RecurrenceType.MonthlyFirstDay:
      return 'custom';
    default:
      return 'none';
  }
};
